import { eIntegrationStatus, eIntegrationType } from './Integrations.enums';
import { tIntegrationsContext } from './Integrations.types';

export const initialState: tIntegrationsContext = {
  integrations: [],
  setIntegrations: () => {},
  selectedIntegration: null,
  setSelectedIntegration: () => {},
  whatsappIntegration: {
    label: eIntegrationType.WHATSAPP_WEB,
    state: eIntegrationStatus.DISCONNECTED,
  },
  setWhatsappIntegration: () => {},
  facebookIntegration: {
    label: eIntegrationType.MESSENGER,
    state: eIntegrationStatus.DISCONNECTED,
  },
  setFacebookIntegration: () => {},
  instagramIntegration: {
    label: eIntegrationType.INSTAGRAM,
    state: eIntegrationStatus.DISCONNECTED,
  },
  setInstagramIntegration: () => {},
  // The WhatsApp API channel is UNKNOWN until the fetch resolves. bff-web
  // answers for a workspace that never connected a WABA with a row at
  // NO_ACCOUNT, so this default is what that answer confirms — "don't know"
  // must never be published as the alarm a real disconnect raises.
  whatsappBusinessIntegration: {
    label: eIntegrationType.WHATSAPP_API,
    state: eIntegrationStatus.NO_ACCOUNT,
  },
  setWhatsappBusinessIntegration: () => {},
  tiktokIntegration: {
    label: eIntegrationType.TIKTOK,
    state: eIntegrationStatus.DISCONNECTED,
  },
  setTiktokIntegration: () => {},
  hasTiktokIntegration: () => false,
  isIntegrationModalOpen: false,
  setIsIntegrationModalOpen: () => {},
  checkAndDeleteBannedAccount: () => Promise.resolve(),
  hasWaBusinessIntegration: () => false,
  hasWaWebAccount: () => false,
  refetchIntegrations: () => Promise.resolve(),
  isHydrated: false,
  channelsInLatestResponse: [],
};

/**
 * Backoff before the single retry of a connection-event refetch. Short enough
 * that the connection acknowledgement still feels immediate, long enough to
 * clear a transient failure.
 */
export const REFETCH_RETRY_DELAY_MS = 2_000;
